import React from 'react'
import mainContentStar from '../assets/img/grafika/ZVIJEZDA-natpis-HR.png'
import mainContentPrizes from '../assets/img/HR-ZBIRNE-nagrade.png'

const DobitniciContent = () => {

  return (
    <article className="mainContent pb-6">
      <div className="px-2 lg:px-9 mt-10 lg:mt-2">
        <h3 className="font-bold text-xl sm:text-2xl lg:text-3xl max-w-[60ch] mx-auto mb-6 lg:mb-6">Zmagovalci</h3>
        <div className="flex flex-wrap justify-between">
          <div className="flex-1 min-w-full md:min-w-[33%] px-0 md:px-2 mb-8">
          <p className='font-bold'>10 x BOSCH cvrtnik na vroči zrak MAF462B1</p>
          
            <p>Nika Nikolić, Koper</p>
          
            <p>Dušanka Razgor, Velenje</p>
            
            <p>Eva Pustinek, Mislinja</p>
            
            <p>Lora Kašnik, Slovenj Gradec</p>
           
            <p>Ervin Vehabović, Velenje</p>
           
            <p>Irena Perpar, Šentvid pri Stični</p>
           
            <p>Mojca Zupanc, Zagorje ob Savi</p>
            
            <p>Mateja Sajovic, Murska Sobota</p>
           
            <p>Damjan Drašler, Črnuče</p>
            
            <p>Matic Muhič, Trebnje</p>
          </div>
          <div className="flex-1 min-w-full md:min-w-[33%] px-0 md:px-2">
          <p className='font-bold '>10 x Dr. Oetker darilni paket</p>
          
            <p>Cvetka Majcenič, Jurovski Dol</p>
            
            <p>Dalibor Savanović, Ljubljana</p>
            
            <p>Matej Bevc, Gabrovka</p>
           
            <p>Primož Ferjančič, Vipava</p>
            
            <p>Franci Bertoncelj, Škovja Loka</p>
           
            <p>Anja Samsa, Prem</p>
            
            <p>Marjeta Kocbek, Grad</p>
           
            <p>Mateja Marolt, Ljubljana</p>
            
            <p>Silva Zemljič, Maribor</p>
           
            <p>Boris Karamatić, Ljubljana</p>
          </div>
        </div>
      </div>
    </article>
  )

}

export default DobitniciContent